import { Nullable } from "./Extensions";
import { NAMESPACE } from "./_Namespace";
import { Service } from "./Service";

const
    services = new Map<{ new(...args: any): Service<any> }, Object>();

export class ServiceManager
{
    public static classNamespace = NAMESPACE + "ServiceManager";
    public static className = "ServiceManager";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    public static add<T extends Object>(service: { new(...args: any): Service<T> }, implementationInstance: T): void
    {
        services.set(service, implementationInstance);
    }

    public static getOptional<T extends Object>(service: { new(...args: any): Service<T> }): Nullable<T>
    {
        return services.get(service) as Nullable<T>;
    }

    public static getRequired<T extends Object>(service: { new(...args: any): Service<T> }): T
    {
        const
            implementationInstance = this.getOptional(service);

        if (!implementationInstance)
            throw new Error(`Service \"${service.name}\" not found`);

        return implementationInstance;
    }
}